import userFiltersSignal, {
	setUserFilters,
} from '@UI/Pages/Administration/Users/Filters/Signals/userFiltersSignal';
import type RoleView from '@UI/Store/Roles/Views/RoleView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	/** `null` while still loading. */
	readonly roles: readonly RoleView[] | null;
	readonly withLabel?: boolean;
};

const RoleFilter: React.FC<Props> = ({ roles, withLabel = false }) => {
	const currentFilters = useSignalValue(userFiltersSignal);

	const handleRoleChange = React.useCallback((roleId: number | null) => {
		setUserFilters(userFiltersSignal.peek().setRoleId(roleId));
	}, []);

	return (
		<Dropdown<number>
			name="userRole"
			label="Rôle"
			isLabelHidden={!withLabel}
			placeholder="Tous les rôles"
			options={roles ?? []}
			optionLabel="label"
			optionValue="id"
			loading={roles === null}
			showClear
			value={currentFilters.roleId}
			onChange={handleRoleChange}
		/>
	);
};

export default RoleFilter;
